// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

export default function AddToClausesListBtn(props) {
  return (
    <Tooltip
      placement="top"
      overlay="Add to clauses list"
      align={{ offset: [0, 3] }}>
      <span
        className="btn-icon"
        data-test="addtoclauseslistbtn-add-to-clauses-list-btn"
        id="add-to-clauses-list-btn"
        onMouseDown={() => props.btnAction(props.id)}
        // onClick={() => props.btnAction(props.id)}
        // onKeyDown={() => props.btnAction(props.id)}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "save"]} />
      </span>
    </Tooltip>
  );
}
